<template>
  <div
    class="relative overflow-scroll px-24 pb-[140px] md:flex md:grow md:flex-row md:items-stretch md:justify-stretch md:p-0"
  >
    <RevLoadingScreen
      class="bg-surface-default-mid fixed inset-0 z-10 w-full md:absolute md:right-[440px]"
      data-qa="loading-screen"
      data-test="loading-screen"
      :text="i18n(translations.loading)"
    />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

import { useLogout } from '@backmarket/nuxt-layer-oauth/useLogout'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLoadingScreen } from '@ds/components/LoadingScreen'

import translations from './Logout.translations'

const i18n = useI18n()

const { logout } = useLogout()

onMounted(async () => {
  await logout()
})
</script>
